import { cloneArray, cloneObject, deepCloneArray, getArrayLength, isArrayEmpty, isArrayNotEmpty, isFunction, isNotNullUndefined, isNullUndefined, isObjectNotEmpty, isStringEqual_caseInsensitive, isStringEqual_caseSensitive, isStringTrimNotEmpty } from 'functions';
import React, { useEffect, useState } from 'react';

import "assets/scss/components/filters/multiFilters.scss";
import { Dropdown, SearchBox } from '.';
import { DateRangePicker } from 'components/form/DateRangePicker';
import { Button } from 'components/buttons/Button';
import { Toaster } from 'components/notification/Toaster';
import { Datepicker } from 'components/form/Datepicker';
import moment from 'moment';

export function MultiFilters(props) {
    const {
        filterOptions,
        defaultFilterOption,
        dropdownPlaceholder,
        applyFilterTxt, isApplyFilterDisabled,
        isResetFromParentRequired, isSelectionResetRequired
    } = props;

    const [filterDetails, setFilterDetails] = useState();
    const [selectedLabel, setSelectedLabel] = useState();
    const [inputValue, setInputValue] = useState("");
    const [dropdownValue, setDropdownValue] = useState("");
    const [dropdownLabel, setDropdownLabel] = useState("");
    const [date, setDate] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [isResetRequired, setIsResetRequired] = useState();
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [filterObj, setFilterObj] = useState({});

    function onChange_dropdown(value, label, index) {
        if (isArrayNotEmpty(filterOptions) &&
            index <= filterOptions.length) {
            let filterDetails = filterOptions[index];
            if (filterDetails) setFilterDetails(filterDetails);

            resetInputs();

            setSelectedLabel(label);
        }
    }
    function resetInputs() {
        setInputValue("");
        setDropdownValue("");
        setDropdownLabel("");
        setDate("");
        setFromDate("");
        setToDate("");
    }
    useEffect(() => {
        if (isObjectNotEmpty(defaultFilterOption)) {
            setFilterDetails(defaultFilterOption);
            setSelectedLabel(defaultFilterOption?.label);
        }
    }, [JSON.stringify(defaultFilterOption)]);
    function resetEverything() {
        setIsResetRequired(true);
        setSelectedFilters([]);
        setFilterDetails(defaultFilterOption ? defaultFilterOption : {});
        setFilterObj({});
        setSelectedLabel(defaultFilterOption?.label);
        resetInputs();
    }
    useEffect(() => {
        if (isResetFromParentRequired) {
            resetEverything();
        }
    }, [isResetFromParentRequired]);
    useEffect(() => {
        if (isResetRequired) setIsResetRequired(false);
    }, [isResetRequired]);

    function applyFilter() {
        setIsResetRequired(true);

        let newFilter = cloneArray(selectedFilters);
        let propertyName, isPropertyFound;

        switch (filterDetails?.inputType) {
            case "dateRange":
                if (isStringTrimNotEmpty(fromDate) &&
                    isStringTrimNotEmpty(toDate)) {

                    let propertyName_start = filterDetails?.propertyName_start;
                    let propertyName_end = filterDetails?.propertyName_end;

                    let fromDate_formatted = moment(fromDate);
                    let toDate_formatted = moment(toDate);

                    // Check for existed selected filter
                    let isPropertyFound = false;
                    selectedFilters.map((obj, idx) => {
                        let existing_propertyName_start = obj?.propertyName_start;
                        let existing_propertyName_end = obj?.propertyName_end;
                        if (isStringEqual_caseSensitive(existing_propertyName_start, propertyName_start) &&
                            isStringEqual_caseSensitive(existing_propertyName_end, propertyName_end)) {
                            isPropertyFound = true;

                            if (newFilter[idx]?.labelName)
                                newFilter[idx].labelName = selectedLabel + ": " + fromDate_formatted.format("DD-MM-YYYY") + " - " + toDate_formatted.endOf("month").format("DD-MM-YYYY");
                        }
                    });

                    if (!isPropertyFound) {
                        newFilter.push({
                            labelName: selectedLabel + ": " + fromDate_formatted.format("DD-MM-YYYY") + " - " + toDate_formatted.endOf("month").format("DD-MM-YYYY"),
                            propertyName_start,
                            propertyName_end
                        });
                    }


                    if (isStringTrimNotEmpty(propertyName_start) &&
                        isStringTrimNotEmpty(propertyName_end)) {
                        let obj = cloneObject(filterObj);
                        obj[propertyName_start] = fromDate_formatted.utc(true).format("YYYY-MM-DD");
                        obj[propertyName_end] = toDate_formatted.endOf('month').utc(true).format("YYYY-MM-DD");

                        // obj[propertyName_start] = fromDate_formatted.utc(true).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
                        // obj[propertyName_end] = toDate_formatted.endOf('month').utc(true).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
                        setFilterObj(obj);

                        if (isFunction(props.onApplyFilter))
                            props.onApplyFilter(obj);
                    }
                }
                else {
                    Toaster({ type: "info", msg: "Start & End dates required" });
                }
                break;
            case "date":
                propertyName = filterDetails?.propertyName;

                // Check for existed selected filter
                isPropertyFound = false;
                let dateDisplayFormat = moment(date).format("DD-MM-YYYY");
                if (dateOptions?.showQuarterYearPicker) {
                    dateDisplayFormat = moment(date).format("Q");
                }
                selectedFilters.map((obj, idx) => {
                    let existing_propertyName = obj?.propertyName;
                    if (isStringEqual_caseSensitive(existing_propertyName, propertyName)) {
                        isPropertyFound = true;

                        if (newFilter[idx]?.labelName) {
                            newFilter[idx].labelName = selectedLabel + ": " + dateDisplayFormat;
                        }
                    }
                });

                if (!isPropertyFound) {
                    newFilter.push({
                        labelName: selectedLabel + ": " + dateDisplayFormat,
                        propertyName
                    });
                }

                if (isStringTrimNotEmpty(propertyName)) {
                    let obj = cloneObject(filterObj);
                    obj[propertyName] = moment(date).format("YYYY/MM/DD");
                    setFilterObj(obj);

                    if (isFunction(props.onApplyFilter))
                        props.onApplyFilter(obj);
                }
                break;
            case "search":
                if (inputValue != "") {
                    propertyName = filterDetails?.propertyName;

                    // Check for existed selected filter
                    isPropertyFound = false;
                    selectedFilters.map((obj, idx) => {
                        let existing_propertyName = obj?.propertyName;
                        if (isStringEqual_caseSensitive(existing_propertyName, propertyName)) {
                            isPropertyFound = true;
    
                            if (newFilter[idx]?.labelName)
                                newFilter[idx].labelName = selectedLabel + ": " + inputValue;
                        }
                    });
    
                    if (!isPropertyFound) {
                        newFilter.push({
                            labelName: selectedLabel + ": " + inputValue,
                            propertyName
                        });
                    }
    
                    if (isStringTrimNotEmpty(propertyName)) {
                        let obj = cloneObject(filterObj);
                        obj[propertyName] = inputValue;
                        setFilterObj(obj);
    
                        if (isFunction(props.onApplyFilter))
                            props.onApplyFilter(obj);
                    }
                }
                else {
                    Toaster({ type: "info", msg: "Input required" });
                }
                break;
            case "dropdown":
                if (isStringTrimNotEmpty(dropdownLabel)) {
                    propertyName = filterDetails?.propertyName;

                    // Check for existed selected filter
                    isPropertyFound = false;
                    selectedFilters.map((obj, idx) => {
                        let existing_propertyName = obj?.propertyName;
                        if (isStringEqual_caseSensitive(existing_propertyName, propertyName)) {
                            isPropertyFound = true;
    
                            if (newFilter[idx]?.labelName)
                                newFilter[idx].labelName = selectedLabel + ": " + dropdownLabel;
                        }
                    });
    
                    if (!isPropertyFound) {
                        newFilter.push({
                            labelName: selectedLabel + ": " + dropdownLabel,
                            propertyName
                        });
                    }
    
                    if (isStringTrimNotEmpty(propertyName)) {
                        let obj = cloneObject(filterObj);
                        obj[propertyName] = dropdownValue;
                        setFilterObj(obj);
    
                        if (isFunction(props.onApplyFilter))
                            props.onApplyFilter(obj);
                    }
                }
                else {
                    Toaster({ type: "info", msg: "Selection required" });
                }   
                break;
            default: break;
        }

        setSelectedFilters(newFilter);
    }

    let placeholder = filterDetails?.placeholder;
    let placeholder_start = filterDetails?.placeholder_start;
    let placeholder_end = filterDetails?.placeholder_end;
    let suggestionList = filterDetails?.suggestionList;
    let inputType = filterDetails?.inputType;
    let isInputDigitOnly = filterDetails?.isInputDigitOnly;
    let options = filterDetails?.options;
    let isDisabled = filterDetails?.isDisabled;
    let isNotUsingMonthYear = filterDetails?.isNotUsingMonthYear;
    let dateOptions = filterDetails?.dateOptions;
    let updateParent = isFunction(filterDetails?.updateParent) ? filterDetails?.updateParent : () => { };
    let updateStartDateParent = isFunction(filterDetails?.updateStartDateParent) ? filterDetails?.updateStartDateParent : () => { };
    let updateEndDateParent = isFunction(filterDetails?.updateEndDateParent) ? filterDetails?.updateEndDateParent : () => { };
    if (isArrayEmpty(filterOptions)) return "";

    return (
        <div className={"component-multi-filters"}>
            <div className={"component-multi-filters__input d-flex align-items-center"}>
                {/* Dropdown Options */}
                <Dropdown
                    selectedValueWrapperClassName={"input__dropdown-options " +
                        (isNullUndefined(inputType) ? "input__dropdown-options_border " : "")}
                    placeholder={dropdownPlaceholder ? dropdownPlaceholder : "Select..."}
                    selectedValue_default={filterDetails?.value}
                    selectedValueLabel_default={filterDetails?.label}
                    options={filterOptions}
                    onChange={(value, label, index) => {
                        onChange_dropdown(value, label, index);
                        updateParent(value, label, index);
                    }}
                    isResetRequired={isResetRequired && isSelectionResetRequired}
                    isUpdatingLabel_fromParent
                />

                {isNotNullUndefined(inputType) ? (
                    <div className={"input__wrapper d-flex align-items-center " +
                        (isDisabled ? "input__wrapper_disabled " : "")}
                    >
                        {/* Input */}
                        <div className={"input__multi-inputs"}>
                            {/* Search Box */}
                            {(isStringEqual_caseInsensitive(inputType, "search")) ? (
                                <SearchBox
                                    className={"multi-inputs__search-box"}
                                    inputClassName={"search-box__input"}
                                    sideIconClassName={"saerch-box__icon"}
                                    placeholder={placeholder ? placeholder : "Search..."}
                                    isSuggestionListRequired={isArrayNotEmpty(suggestionList)}
                                    suggestionList={suggestionList}

                                    handleOnChange={(value) => {
                                        setInputValue(value);
                                        updateParent(value);
                                    }}

                                    onEnterPressed={applyFilter}

                                    isResetRequired={isResetRequired}
                                    isIconOnLeftSide
                                    isInputDigitOnly={isInputDigitOnly}
                                    isDisabled={isDisabled}
                                />
                            ) : ""}

                            {/* Dropdown */}
                            {(isStringEqual_caseInsensitive(inputType, "dropdown")) ? (
                                <Dropdown
                                    className={"multi-inputs__dropdown"}
                                    selectedValueWrapperClassName={"dropdown__input"}
                                    optionListClassName={"dropdown__option-list"}
                                    placeholder={placeholder ? placeholder : "Select..."}
                                    options={options}
                                    onChange={(value, label) => {
                                        setDropdownValue(value);
                                        setDropdownLabel(label);
                                        updateParent(value);
                                    }}
                                    onEnterKeyPressed={applyFilter} isSearchable
                                    isDisabled={isDisabled}
                                    isResetRequired={isResetRequired}
                                />
                            ) : ""}


                            {/* Date */}
                            {(isStringEqual_caseInsensitive(inputType, "date")) ? (
                                <Datepicker
                                    inputClassName={"multi-inputs__date"}
                                    placeholder={placeholder ? placeholder : "Select Date"}
                                    handleOnChange={(date) => {
                                        setDate(date);
                                        updateParent(date);
                                    }}
                                    isDisabled={isDisabled}
                                    isResetRequired={isResetRequired}
                                    otherOptions={dateOptions}
                                />
                            ) : ""}

                            {/* Date Range */}
                            {(isStringEqual_caseInsensitive(inputType, "dateRange")) ? (
                                <DateRangePicker
                                    inputWrapperClassName={"input__date-range-picker"}
                                    startClassName={"date-range-picker__start"}
                                    endClassName={"date-range-picker__end"}
                                    placeholder_start={placeholder_start}
                                    placeholder_end={placeholder_end}

                                    handleOnChange_start={(date) => {
                                        setFromDate(date);
                                        updateStartDateParent(date);
                                    }}
                                    handleOnChange_end={(date) => {
                                        setToDate(date);
                                        updateEndDateParent(date);
                                    }}

                                    startDateOptions={{
                                        isMonthYear: !isNotUsingMonthYear,
                                        dateFormat: !isNotUsingMonthYear ? "MM/yyyy" : undefined
                                    }}
                                    endDateOptions={{
                                        isMonthYear: !isNotUsingMonthYear,
                                        dateFormat: !isNotUsingMonthYear ? "MM/yyyy" : undefined
                                    }}

                                    isDisabled={isDisabled}
                                    isResetRequired={isResetRequired}
                                    isConversionRequired_ISO8601
                                />
                            ) : ""}
                        </div>

                        {/* Apply Filter */}
                        <Button
                            className={"input__apply-filter"}
                            handleOnClick={applyFilter}
                            isDisbaled={isApplyFilterDisabled}
                        >
                            {applyFilterTxt ? applyFilterTxt : "Filter"}
                        </Button>
                    </div>
                ) : ""}
            </div>


            {/* Selected Filters */}
            {isArrayNotEmpty(selectedFilters) ? (
                <div className={"component-multi-filters__selected-filters d-flex"}>
                    {/* Label */}
                    <div className={"selected-filters__label d-flex align-items-center"}>
                        Filters:
                    </div>

                    {/* Selections */}
                    <div className={"selected-filters__selections d-flex align-items-center flex-wrap"}>
                        {selectedFilters.map((labelDetails, idx) => {
                            let name = labelDetails?.labelName;
                            let propertyName = labelDetails?.propertyName;

                            let propertyName_start, propertyName_end;
                            if (isNullUndefined(propertyName)) {
                                propertyName_start = labelDetails?.propertyName_start;
                                propertyName_end = labelDetails?.propertyName_end;
                            }

                            return (
                                <div key={idx} className={"selections__wrapper"}>
                                    <div className={"selections__item"}
                                        onClick={() => {
                                            let newFilter = deepCloneArray(selectedFilters);
                                            newFilter.splice(idx, 1);
                                            setSelectedFilters(newFilter);

                                            let obj = cloneObject(filterObj);
                                            if (isNullUndefined(propertyName)) {
                                                obj[propertyName_start] = "";
                                                obj[propertyName_end] = "";
                                            }
                                            else obj[propertyName] = "";
                                            setFilterObj(obj);

                                            if (isFunction(props.onApplyFilter))
                                                props.onApplyFilter(obj);

                                            resetInputs();
                                        }}
                                    >
                                        {name}
                                        <span className={"item__close"} />
                                    </div>
                                </div>
                            )
                        })}

                        {/* Clear All */}
                        <div className={"selections__clear-all"}>
                            <div className={"clear-all__wrapper"}
                                onClick={() => {
                                    resetEverything();

                                    if (isFunction(props.onApplyFilter))
                                        props.onApplyFilter({});
                                }}
                            >
                                Clear All
                            </div>
                        </div>
                    </div>
                </div>
            ) : ""}
        </div>
    );
}